export interface IStockGeneral {
    default_metric_unit_size: string;
    default_metric_unit_weight: string;
    default_troy_ounce_show: number;
    stock_default_price_visible: number;
    stock_default_available_to_buy: number;
    next_stock_number: string;
    item_detail_page_message: { [key: string]: string };
}
